import angular from 'angular';
import { MensagemErroInputController } from './mensagem-erro-input.controller';
import { MensagemErroInputComponent } from './mensagem-erro-input.component';

export const MensagemErroInputModule = angular.module('MensagemErroInputModule', ['ui.router.state'])
    .controller('MensagemErroInputController', MensagemErroInputController)
    .component(MensagemErroInputComponent.selector, MensagemErroInputComponent)
    .name;
